import buildBaseImgSrc, { wrapWithEnvParam } from './buildBaseImgSrc';

export { wrapWithEnvParam };
export default buildBaseImgSrc;
